<script>
/**
 * It is possible to create one generic icon component to load icons,
 * but it is not recommended.
 *
 * e.g import * as icons from "lucide-svelte";
 */
import {
  Bell,
  Check,
  Copy,
  Github,
  Image,
  Linkedin,
  Mastodon,
  MoveUp,
  FileQuestion,
  FileText,
  X,
  CircleX,
  Info,
  TriangleAlert,
} from "./index";

// <LucideIcon name="Instagram" />
// <LucideIcon name="Linkedin" />
// <LucideIcon name="Figma" />

let { name, ...rest } = $props();

const icons = {
  Bell,
  Check,
  Copy,
  Github,
  Image,
  Linkedin,
  Mastodon,
  MoveUp,
  FileQuestion,
  FileText,
  X,
  CircleX,
  Info,
  TriangleAlert,
};

const IconComponent = $derived(icons[name] ?? FileQuestion);
</script>

<IconComponent {...rest} />
